import React, { useState } from "react";
import "./css/wallet.css";
import { NotesCommonCustomerProfile } from "../CommonComponent/Notes/MainNotesCustomerProfile";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { WalletStripeCardPayment } from "./component/StripeCardPayment/StripeCardpayment";

// Payment method options
const PAYMENT_OPTIONS = [
  { label: "Credit Card", value: "Credit Card" },
  {
    label: "Direct Wallet Deposit",
    value: "Direct Wallet Deposit",
    disabled: true,
  },
];

export const Wallet = ({ setRefreshCustomerData, cpData }) => {
  // -------------------- Validation Schema --------------------
  const validationSchema = Yup.object().shape({
    amount: Yup.number().required("Field Is Required"),
    paymentMethod: Yup.string().required("Field Is Required"),
  });

  // -------------------- Local States --------------------
  const [showPaymentMethodError, setShowPaymentMethodError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [refreshNotes, setRefreshNotes] = useState(false);

  // -------------------- Formik --------------------
  const formik = useFormik({
    initialValues: {
      amount: "",
      paymentMethod: "",
    },
    validationSchema,
    onSubmit: () => {
      // handled via payment components
    },
  });

  const clearWalletFields = () => {
    formik.resetForm();
    setShowAmountError(false);
    setShowPaymentMethodError(false);
  };

  // -------------------- Helpers --------------------
  const validateAmount = (value) => {
    if (!value || Number(value) <= 0) {
      setShowAmountError(true);
      return false;
    }
    setShowAmountError(false);
    return true;
  };

  return (
    <div className="main-wallet-container">
      <div className="wallet-wrapper">
        {/* ---------------- Header ---------------- */}
        <div className="wallet-top-header">
          <p>Wallet</p>
          <p>
            Add funds to the customer wallet by entering the amount and card
            details.
          </p>
        </div>

        {/* ---------------- Customer Details ---------------- */}
        <div className="wallet-customer-details">
          <div className="wallet-customer-item">
            <p>Customer ID</p>
            <p>{cpData?.enrollmentId || "NIL"}</p>
          </div>

          <div className="wallet-customer-item">
            <p>Customer Name</p>
            <p>
              {cpData?.firstName
                ? `${cpData?.firstName} ${cpData?.lastName || ""}`
                : "NIL"}
            </p>
          </div>

          <div className="wallet-customer-item">
            <p>Phone Number</p>
            <p>{cpData?.contact || "NIL"}</p>
          </div>

          <div className="wallet-customer-item">
            <p>Wallet Amount</p>
            <p>
              {cpData?.wallet
                ? `${parseFloat(cpData.wallet).toFixed(2)}$`
                : "NIL"}
            </p>
          </div>
        </div>

        {/* ---------------- Payment Section ---------------- */}
        <div className="wallet-card-details">
          <div className="card-detail-main">
            <p className="card-detail-header">Payment Options</p>

            {/* Amount */}
            <div className="card-detail-inputcontainer">
              <div className="flex justify-content-between w-full">
                <label>Amount</label>
                {showAmountError && <label>Field Is Required</label>}
              </div>

              <input
                name="amount"
                type="number"
                placeholder="Amount"
                value={formik.values.amount}
                className={`main-drop ${showAmountError ? "p-invalid" : ""}`}
                onChange={(e) => {
                  formik.handleChange(e);
                  validateAmount(e.target.value);
                }}
              />
            </div>

            {/* Payment Method */}
            <div className="card-detail-inputcontainer">
              <div className="flex justify-content-between w-full">
                <label>Payment Method</label>
                {showPaymentMethodError && <label>Field Is Required</label>}
              </div>

              <Dropdown
                name="paymentMethod"
                options={PAYMENT_OPTIONS}
                placeholder="Payment Method"
                value={formik.values.paymentMethod}
                className={`main-drop ${
                  showPaymentMethodError ? "p-invalid" : ""
                }`}
                onChange={(e) => {
                  formik.handleChange(e);
                  setShowPaymentMethodError(false);
                }}
              />
            </div>
          </div>
        </div>

        {/* ---------------- Conditional Rendering ---------------- */}
        {formik.values.paymentMethod === "Credit Card" ? (
          <WalletStripeCardPayment
            amount={formik.values.amount}
            cpData={cpData}
            setRefreshCustomerData={setRefreshCustomerData}
            setRefreshNotes={setRefreshNotes}
            setShowAmountError={setShowAmountError}
            onPaymentSuccess={clearWalletFields}
          />
        ) : (
          <div className="wallet-pay-button flex justify-content-end">
            <Button
              label="Pay Now"
              onClick={() => {
                validateAmount(formik.values.amount);

                if (!formik.values.paymentMethod) {
                  setShowPaymentMethodError(true);
                }
              }}
            />
          </div>
        )}
      </div>

      {/* ---------------- Notes ---------------- */}
      <div className="wallet-notes-container">
        <NotesCommonCustomerProfile
          refreshNotes={refreshNotes}
          cpData={cpData}
        />
      </div>
    </div>
  );
};
